module.exports = "/images/gotham-17.jpg";